var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { useShowScrollHint } from '../hooks';
import { bodyWrapperStyle, bodyShadowsStyle, bodyStyle } from './styles';
import { useDialog } from './dialog-context';
function Body(_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    var bodyRef = useRef(null);
    var _b = useShowScrollHint(bodyRef, 'vertical'), isShadowTopVisible = _b.showStartHint, isShadowBottomVisible = _b.showEndHint;
    var bodyId = useDialog().bodyId;
    return (_jsxs("div", __assign({ css: bodyWrapperStyle() }, { children: [_jsx("div", { css: bodyShadowsStyle({
                    isShadowTopVisible: isShadowTopVisible,
                    isShadowBottomVisible: isShadowBottomVisible,
                }) }), _jsx("div", __assign({ css: bodyStyle(), id: bodyId, ref: bodyRef }, restProps, { children: children }))] })));
}
export default Body;
